import {
  Dialog,
  DialogContent,
  DialogTitle,
  CircularProgress,
} from "@material-ui/core/";
import { Form, Formik } from "formik";
import { FaTimes } from "react-icons/fa";
import validationSchema from "../../../Validation/ValidationSchemas";
import FormikTextField from "../../../Common/FormFields/FormikInputField";
import { useEffect, useState } from "react";
import { FormGroup } from "reactstrap";
import CustomDropDown from "../../../Common/FormFields/CustomDropDown";
import { useSelector } from "react-redux";
const AddNewFilterDialog = ({
  successPopUp,
  toggleAddPopUpDialog,
  addFilter,
  updateFilter,
}) => {
  const {
    isEditFilter,
    filterData: editFilterInformation,
    loading,
  } = useSelector((state) => state.videoLibraryFilterData);
  const activeBreakDownList = useSelector(
    (state) => state?.VideoLibraryDataTable?.activeBreakDownList
  );
  const [breakdownName, setBreakDownName] = useState(
    editFilterInformation ? editFilterInformation?.breakdown?.breakdownName : ""
  );
  const [condition, setCondition] = useState(
    editFilterInformation ? editFilterInformation?.newCriteria : ""
  );

  useEffect(() => {
    return () => {
      setBreakDownName("");
      setCondition("");
    };
  }, []);

  const conditionOptions = () => {
    let status = false;
    if (breakdownName) {
      const index = activeBreakDownList?.findIndex(
        (item) => item?.breakdownName === breakdownName
      );
      if (
        activeBreakDownList?.[index].breakdownType.breakdownTypeName === "Text"
      ) {
        setCondition("EqualTo");
        status = true;
      }
    }
    let optionList = [
      {
        name: "EqualTo",
        disabled: false,
      },
      {
        name: "NotEqualTo",
        disabled: status,
      },
      {
        name: "GreaterThan",
        disabled: status,
      },
      {
        name: "LessThan",
        disabled: status,
      },
      {
        name: "Between",
        disabled: status,
      },
    ];

    return optionList;
  };

  return (
    <Dialog
      id="dialogBoxRemove"
      className="dialog-stylee"
      open={successPopUp}
      onClose={() => toggleAddPopUpDialog(false)}
    >
      <DialogTitle>
        <div className="row">
          <div className="col-1 text-right ml-auto">
            <FaTimes
              onClick={(event) => {
                event.stopPropagation();
                toggleAddPopUpDialog(false);
              }}
              className="crossview cp"
            />
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <div className="addFilterPopupContent">
          <div>
            <Formik
              initialValues={{
                filterName: editFilterInformation
                  ? editFilterInformation?.filterName
                  : "",
                breakdownName: editFilterInformation
                  ? editFilterInformation?.breakdown?.breakdownName
                  : "",
                conditionName: editFilterInformation
                  ? editFilterInformation?.newCriteria
                  : "",
                conditionValue: editFilterInformation
                  ? editFilterInformation.value
                  : "",
              }}
              validationSchema={validationSchema.EditFilterSchema}
              onSubmit={(values, { setSubmitting }) => {
                setSubmitting(true);
                updateFilter(values, editFilterInformation?.id);
                setSubmitting(false);
              }}
            >
              {(formik) => (
                <Form className="fs-16">
                  <FormikTextField
                    label="Filter Name"
                    formik={formik}
                    fieldName="filterName"
                    placeholder="Enter Filter name"
                    labelFontSize="fs-16"
                  />
                  <FormGroup className="fs-16">
                    <label className="fmlabel mt-6 semi-bold fs-18">
                      Breakdown <span className="redstar">*</span>
                    </label>
                    <CustomDropDown
                      selected={formik.values.breakdownName}
                      setSelected={setBreakDownName}
                      formik={formik}
                      fieldName="breakdownName"
                      defaultSelectOption="Select BreakDown"
                      options={activeBreakDownList}
                      fieldToShow="breakdownName"
                      optionValue="breakdownName"
                    />
                  </FormGroup>
                  <FormGroup>
                    <label className="fmlabel mt-6 semi-bold fs-18">
                      Condition <span className="redstar">*</span>
                    </label>
                    <CustomDropDown
                      selected={formik.values.conditionName}
                      setSelected={setCondition}
                      formik={formik}
                      fieldName="conditionName"
                      defaultSelectOption="Select Condition"
                      options={conditionOptions()}
                      fieldToShow="name"
                      optionValue="name"
                      isDisabled="disabled"
                    />
                  </FormGroup>
                  <FormikTextField
                    label="Condition Value"
                    formik={formik}
                    fieldName="conditionValue"
                    placeholder="Set Condition Value"
                    labelFontSize="fs-16"
                  />
                  <div className="d-flex-align-right">
                    <button
                      type="submit"
                      className={`mg-top-20 ${
                        formik.isValid ? "saveBtn1" : "saveBtn1 activv"
                      }`}
                      disabled={!formik.isValid}
                    >
                      {loading?.buttonLoading ? (
                        <CircularProgress size="1.5rem" className="white" />
                      ) : isEditFilter ? (
                        "Update"
                      ) : (
                        "Add"
                      )}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>

        <div className="clear10"></div>
      </DialogContent>
    </Dialog>
  );
};

export default AddNewFilterDialog;
